import classnames from 'classnames';
import { useFormContext } from 'react-hook-form';
import { FormGroup, Label, Table } from 'reactstrap';
import { CylinderIdentity, CylinderIdentityArray , CylinderDescription} from '../../../../../models/rewards/calor/Claim';
import { CylinderPurchaseDetails } from '../../../../../models/rewards/calor/ClaimForm';
import VatPrice from '../../../../../models/VatPrice';
import { CylinderQuantityInput, IncludesVatCheckbox, PerCylinderPriceInput } from './_inputs';
import { calculateTotals, DisplayTotal } from './_totals';

export const purchaseDetailsPropertyName = (identity: CylinderIdentity): string => `purchaseDetails${identity}`;

const PurchaseDetailsGroup = () => {
    const {watch, formState} = useFormContext(); 
    
    const totals = calculateTotals(
        watch(purchaseDetailsPropertyName('13kgCommercial')) as CylinderPurchaseDetails,
        watch(purchaseDetailsPropertyName('13kgPatio')) as CylinderPurchaseDetails,
        watch(purchaseDetailsPropertyName('19kgCommercial')) as CylinderPurchaseDetails,
        watch(purchaseDetailsPropertyName('47kgCommercial')) as CylinderPurchaseDetails);

    const totalQuantityInvalid = formState.isSubmitted && totals.quantity < 1;

    return <>
        <Label className='mb-0' for='claim-details'>Receipt details:</Label>
        <p>One claim per receipt and receipt must reflect the claim.</p>

        <FormGroup id='claim-details'>
            <Table responsive className='text-center'>
                <thead>
                    <tr>
                        <th className='align-middle border-top-0'>Description</th>
                        <th className='align-middle border-top-0'>Quantity</th>
                        <th className='align-middle border-top-0'>Price per Cylinder</th>
                        <th className='align-middle border-top-0'>VAT</th>
                        <th className='align-middle border-top-0'>Total inc. VAT</th>
                        <th className='align-middle border-top-0'>Total exc. VAT</th>
                    </tr>
                </thead>
                <tbody>
                    {CylinderIdentityArray.map((identity: CylinderIdentity) => {
                        const rowTotals = totals[`totals${identity}`] as VatPrice;
                        return (
                            <tr key={`row-${identity}`}>
                                <td className='align-middle'>{CylinderDescription(identity)}</td>
                                <td className='align-middle'><CylinderQuantityInput Identity={identity}/></td>
                                <td className='align-middle'><PerCylinderPriceInput Identity={identity}/></td>
                                <td className='align-middle'><IncludesVatCheckbox Identity={identity}/></td>
                                <td className='align-middle'><DisplayTotal total={rowTotals.incVat}/></td>
                                <td className='align-middle'><DisplayTotal total={rowTotals.excVat}/></td>
                            </tr>
                        );
                    })}

                    <tr>
                        <th className='align-middle'>Total</th>
                        <th className={classnames('align-middle', {'text-danger': totalQuantityInvalid})}>{totals.quantity}</th>
                        <th></th>
                        <th></th>
                        <th className='align-middle'><DisplayTotal total={totals.totalOfTotals.incVat}/></th>
                        <th className='align-middle'><DisplayTotal total={totals.totalOfTotals.excVat}/></th>
                    </tr>
                </tbody>
            </Table>

            {totalQuantityInvalid && <span className='d-block text-danger'>Purchase details required</span>}
        </FormGroup>

        <p>
            <span>Cashback is only paid on exec VAT prices not inc. VAT.</span><br></br>
            <span className='text-uppercase text-primary'>You will be taken off the scheme if you submit false claims.</span>
        </p>
    </>
}

export default PurchaseDetailsGroup;